import { render, staticRenderFns } from "./PricingTable.vue?vue&type=template&id=39760a9d&scoped=true&"
import script from "./PricingTable.vue?vue&type=script&lang=js&"
export * from "./PricingTable.vue?vue&type=script&lang=js&"
import style0 from "./css2.css?vue&type=style&index=0&id=39760a9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39760a9d",
  null
  
)

export default component.exports